// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__RmFVD","slider":"switch_slider__mkO7v"};